<template>
	<LayoutAuth>
		<form class="form form--auth" @submit.prevent="resetPassword" novalidate>
			<h1 class="h2">Reset Password</h1>
			<p class="form__subtitle">Enter a new password below.</p>

			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

			<div class="form__group">
				<input id="email" type="email" name="email"
				       class="form__control"
				       placeholder="Enter your email address here..." required
				       v-model="formData.email" v-validate
				       autocomplete="username" />
				<label for="email" class="form__label">Email Address</label>
				<div class="form__validation">{{ errors.first('email') }}</div>
			</div>

			<div class="form__group">
				<input id="password" type="password" name="password"
				       class="form__control"
				       placeholder="Enter your new password here..." required
				       v-model="formData.password" v-validate="'confirmed:password-confirm'"
				       autocomplete="new-password" />
				<label for="password" class="form__label">New Password</label>
				<div class="form__validation">{{ errors.first('password') }}</div>
			</div>

			<div class="form__group">
				<input id="password-confirm" type="password" name="password-confirm"
				       class="form__control"
				       placeholder="Re-enter your new password here..."
				       required v-validate autocomplete="new-password" />
				<label for="password-confirm" class="form__label">Confirm New Password</label>
				<div class="form__validation">{{ errors.first('password-confirm') }}</div>
			</div>

			<div class="form__group form__group--submit">
				<button type="submit" class="btn btn--primary" :disabled="$wait.is('resetPassword')">Reset password</button>
			</div>
		</form>
	</LayoutAuth>
</template>

<script>
	import API from './../api';
	import SvgIcon from './SvgIcon';
	import ValidationAlert from './ValidationAlert';
	import LayoutAuth from './Layout/LayoutAuth';

	export default {
		components: {
			LayoutAuth,
			ValidationAlert,
			SvgIcon,
		},
		props: {
			token: {
				type: String,
				required: true,
			}
		},
		data() {
			return {
				formData: {
					token: this.token,
					email: '',
					password: '',
				},
			}
		},
		methods: {
			resetPassword() {
				this.$wait.start('resetPassword');

				API.resetPassword(this.formData.token, this.formData.email, this.formData.password).then(response => {
					this.$store.commit('setUser', {
						token: response.data.token,
						user: response.data.user,
					});
					this.$router.push('/dashboard');
				}).catch(error => {
					API.mapServerValidation(error.response, this.$validator);
				}).finally(() => {
					this.$wait.end('resetPassword');
				});
			}
		},
	};
</script>
